import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AgentWorkspace from './AgentWorkspace/AgentWorkspace';
import './agent-workspace-page.css';

const KEYS = ['inbox', 'escalations', 'details'];

export default function AgentWorkspacePage() {
  const [params, setParams] = useSearchParams();
  const tab = KEYS.includes(params.get('tab')) ? params.get('tab') : 'inbox';
  const onTabChange = (next) => setParams(next === 'inbox' ? {} : { tab: next }, { replace: true });
  return <div className="aw-page"><AgentWorkspace tab={tab} onTabChange={onTabChange} /></div>;
}
